// @flow
import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import cx from 'classnames';

import ErrorReporter from 'app/components/ErrorReporter';
import PhoneCallMessageItem from 'chat/components/PhoneCallMessageItem';
import type { SequenceItem } from '../chunker';

type Props = {
  items: Array<SequenceItem>,
};

class PhoneCallMessageItems extends React.Component<Props, void> {
  isAuthor() {
    const { item } = this.props.items[0];
    if (item.__typename !== 'PhoneCallItem') {
      return <ErrorReporter error="PhoneCallMessageItems - tried to render with non-messages" />;
    }
    return CurrentUser.getUserUuid() === item.sender.uuid;
  }

  render() {
    if (this.props.items.length <= 0) {
      return null;
    }

    return (
      <div
        className={cx('MessageItems', {
          'MessageItems-self': this.isAuthor(),
          'MessageItems-other': !this.isAuthor(),
        })}>
        {this.props.items.map((item, index) => {
          const phoneCallItem = item.item;
          if (phoneCallItem.__typename !== 'PhoneCallItem') {
            return (
              <ErrorReporter error="PhoneCallMessageItems - tried to render with non-messages" />
            );
          }
          return (
            <PhoneCallMessageItem
              key={item.key}
              message={phoneCallItem}
              lastOfGroup={index === this.props.items.length - 1}
            />
          );
        })}
      </div>
    );
  }
}

export default PhoneCallMessageItems;
